import { EUSLBListItem } from '../../model/EUSLBListItem';
import ServiceEndpoints from "../ServiceEndpoints"

export async function fetchEUSLB(userId: string, userToken?: string) {
    return await fetch(ServiceEndpoints.FetchAllEUSLB, {
        method: 'get',
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + userToken },
    })
        .then(async (resp) => {
            const parsedData: EUSLBListItem[] = await resp.json();
            return parsedData;
        })
        .catch((error) => {
            console.error(error);
            return [];
        });
}


// Function for updating an EUSLB item
export async function UpdateEUSLBById(encryptedId: string, updatedEUSLB: EUSLBListItem, userToken?: string) {
    try {
        const response = await fetch(`${ServiceEndpoints.UpdateEUSLBById}/${encryptedId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json', "Authorization": "Bearer " + userToken,
            },
            // Convert the updatedEUSLB object to a JSON string and include it in the request body
            body: JSON.stringify(updatedEUSLB),
        });

        if (response.ok) {
            // If the update is successful, parse and return the response data (if any)
            return response.json();
        } else {
            // If there is an error response from the server, throw an error
            const errorMessage = await response.text();


            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}


// Function for deleting an EUSLB item
export async function DeleteEUSLBById(id: string, userToken?: string) {
    try {
        // Send a DELETE request to the server's DeleteEUSLB endpoint
        const response = await fetch(`${ServiceEndpoints.DeleteEUSLBById}/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json', "Authorization": "Bearer " + userToken,
            },
        });
        // Check if the response is successful (HTTP status 200-299)
        if (response.ok) {
            // If the deletion is successful, parse and return the response data (if any)
            return response.json();
        } else {
            // If there is an error response from the server, throw an error
            throw new Error('Error deleting EUSLB data.');
        }
    } catch (error) {
        // Handle any errors that occur during the fetch operation
        console.error(error);
        throw error;
    }
}


// Function for creating a new EUSLB item
export async function CreateEUSLB(newEUSLB: EUSLBListItem, userToken?: string) {
    try {
        // Send a POST request to the server's CreateEUSLB endpoint

        const response = await fetch(ServiceEndpoints.CreateEUSLB, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', "Authorization": "Bearer " + userToken,
            },
            body: JSON.stringify(newEUSLB), // Convert the object to JSON string
        });
        // Check if the response is successful (HTTP status 200-299)
        if (response.ok) {
            // If the creation is successful, parse and return the response data (if any)
            return response.json();
        } else {
            // If there is an error response from the server, throw an error
            const errorMessage = await response.text();
            throw new Error(errorMessage);
        }
    } catch (error) {
        // Handle any errors that occur during the fetch operation
        console.error(error);
        throw error;
    }
}



